import {
	SET_ACCESS_TOKEN,
	SET_ACCESS_TOKEN_EXPIRY_TIME,
	SET_AUTH_CATEGORIES,
	SET_ACCOUNT_REALMS,
	SET_ACTIVE_REALM,
	SET_CUSTOMERS_ACTIVE_REALM,
} from '../constants/constants';

export const setAccessToken = (token) => ({
	type: SET_ACCESS_TOKEN,
	payload: token,
});

export const setAccountRealms = (realms) => ({
	type: SET_ACCOUNT_REALMS,
	payload: realms,
});

export const setAccessTokenExpiryTime = (time) => ({
	type: SET_ACCESS_TOKEN_EXPIRY_TIME,
	payload: time,
});

export const setAuthorisedCategories = (categories) => ({
	type: SET_AUTH_CATEGORIES,
	payload: categories,
});

export const setActiveRealm = (realm) => ({
	type: SET_ACTIVE_REALM,
	payload: realm,
});

export const setCustomersActiveRealm = (realm) => ({
	type: SET_CUSTOMERS_ACTIVE_REALM,
	payload: realm,
});
